import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  mounted () {
    let self = this;
    self.data.datasets[0].backgroundColor =  self.getGradient();
    self.$nextTick(function () {
      self.renderChart(self.data, self.options);
    });
  },
  methods: {
    getGradient() {
      let self = this;
      let gradient = this.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);
      gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
      gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
      gradient.addColorStop(1, 'rgba(225,225,225,' + 0.1 + ')');
      return gradient;
    }
  },
  watch: {
    'data': function () {
      let self = this;
      self.data.datasets[0].backgroundColor =  self.$refs.canvas.getContext("2d").createLinearGradient(150.000, 0.000, 150.000, 300.000);

      self.$nextTick(function () {


        self.$data._chart.update();



        /**
        gradient.addColorStop(0, "rgba(228, 50, 41, 1)");
        gradient.addColorStop(0.5, "rgba(228, 50, 41, 0.5)");
        gradient.addColorStop(1, 'rgba(225,225,225,' + opacity + ')');
        return gradient;
**/
     //

      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Tracking/Graphs/Pulse/LineGraph.js